import { forwardRef, type LabelHTMLAttributes } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '../../../utils';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  /**
   * `sm` = 12px, weight 500, muted ink: the compact label of a dense form or
   * filter row (agion/Agion#3405). @default "md"
   */
  size?: 'sm' | 'md';
}

const SIZE = {
  md: 'text-sm font-medium text-text-secondary',
  sm: 'text-xs font-medium text-text-muted',
} as const;

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, size = 'md', children, ...props }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        SIZE[size] ?? SIZE.md,
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="text-error-500 ml-1">*</span>}
    </LabelPrimitive.Root>
  )
);
Label.displayName = 'Label';
